import { createFileRoute, Outlet } from '@tanstack/react-router'

import { isTokenProviderReady, setGlobalGetToken } from '@/lib/auth'

import { AuthLayout } from '@/shared/auth/components/common/layout'
import { requireAuthGuard } from '@/shared/auth/utils/router'

export const Route = createFileRoute('/onboarding')({
	beforeLoad: async ({ context: { clerk }, location }) => {
		requireAuthGuard({
			auth: clerk.auth,
			location,
		})

		// Initialize Token Provider if not already initialized
		if (!isTokenProviderReady() && clerk.auth?.getToken) {
			setGlobalGetToken(clerk.auth.getToken)
		}
	},

	component: RouteComponent,
})

function RouteComponent() {
	return (
		<AuthLayout>
			<Outlet />
		</AuthLayout>
	)
}
